import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexRow from '../../../../components/molecules/FlexRow'

function NoResults ({ message, className, style }) {
  return (
    <FadeIn className={className} style={style}>
      <FlexRow className='p-xl font-size-md items-center justify-center' style={{ color: 'var(--dai-color-text-dim)' }}>
        {message}
      </FlexRow>
    </FadeIn>
  )
}

NoResults.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

NoResults.defaultProps = {
  message: 'No results found'
}

export default NoResults
